import React from "react";
import "./checkbox-square.scss";
import checkboxChecked from "../../static/checkbox-checked.svg";
import checkbox from "../../static/checkbox-not-checked.svg";

const squareCheckbox = props => {
  return (
    <div className="checkbox-container">
      <img role="checkbox" aria-label=" " aria-checked={props.checked} tabIndex="0" src={props.checked ? checkboxChecked : checkbox} onClick={props.click}/>
      <span>{props.label}</span>
    </div>
  );
};

export default squareCheckbox;
